export const buildNumber = '#{Build.BuildNumber}#';
export const version = '#{Build.SourceBranchName}#';
export const latestCommit = '#{Build.SourceVersion}#';
